<template>
  <div id="elementId" style="display: flex; flex-direction: row">
    <l-map
      @ready="initMap()"
      @update:zoom="zoomend()"
      ref="jmMap"
      :zoom="zoom"
      :center="originLatLon || destinationLatLon"
      :style="{
        borderRadius: '0px',
        minHeight: height,
        width: width,
        ...convertStyleStringToObject(mapStyle),
      }"
      :options="mapOptions"
    >
      <l-marker v-if="originLatLon" :lat-lng="originLatLon" :icon="originIcon">
      </l-marker>
      <l-marker
        v-if="destinationLatLon"
        :lat-lng="destinationLatLon"
        :icon="destinationIcon"
      ></l-marker>
      <l-geo-json
        v-for="(geo, i) in optimizedGeoJsonRoutes"
        :geojson="geo"
        :key="i"
        :optionsStyle="
          checkedTransportsDict[geo.transportType]
            ? { color: $vuetify.theme.themes.light.primary, weight: 4 }
            : { color: mapRouteColor, weight: 4, opacity: 0.65 }
        "
      />
      <l-control-zoom
        position="topright"
        style="border-radius: 10px"
        :zoomInText="'+'"
        :zoomOutText="'-'"
        :zoomInTitle="'Zoom in'"
        :zoomOutTitle="'Zoom out'"
      ></l-control-zoom>
      <l-control-scale
        position="topright"
        :imperial="false"
        :metric="true"
        style="border-radius: 10px"
      />
    </l-map>
    <v-snackbar v-model="error.show" bottom right multi-line color="error">
      <v-icon>warning</v-icon>
      {{ error.msg }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="error.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { geoJSON, map } from "leaflet";
import {
  LControlScale,
  LGeoJson,
  LMap,
  LMarker,
  LControlZoom,
} from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css";
// import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import { latLng } from "leaflet";
import distance from "@turf/distance";
import L from "leaflet";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import { world } from "../assets/countries.geo.js";
import { fetchTrainstationsWithRadius } from "../api/api_cleverroute.js";
//@ts-ignore
import { CRS } from "leaflet/dist/leaflet-src.esm";
import { toRaw, watch } from "vue";
// import { createMaterialIcon } from "../utils/map";
import { MapType } from "../model/mapModels";
import { eventBus } from "../utils/eventBus";

export default defineComponent({
  components: {
    LMap,
    LMarker,
    LGeoJson,
    LControlScale,
    LControlZoom,
  },
  props: {
    mapUtilsObj: { type: Object, default: {} },
    disableAutoFocus: { type: Boolean, default: false },
    geojsonRoutes: { type: Array, default: () => [] },
    originLonLatStr: { type: String, default: "" },
    destinationLonLatStr: { type: String, default: "" },
    height: { type: String, default: "auto" },
    width: { type: String, default: "100%" },
    zoomControl: { type: Boolean, default: false },
    routes: { type: Array, default: () => [] },
    transports: { type: Array, default: () => [] },
    /** @param checkedProvidersDict Marker of sharing provider which should be highlighted*/
    checkedProvidersDict: { type: Object, default: () => ({}) },
    /** @param checkedTransportsDict routes of transport types which should be highlighted  */
    checkedTransportsDict: { type: Object, default: () => ({}) },
    arrival: { type: String, default: undefined },
    departure: { type: String, default: undefined },
    mapStyle: { type: String, default: "" },
    mapRouteColor: { type: String, default: "green" },
    mapIconColor: { type: String, default: "green" },
    /** @param dict with Leaflet-Layers with marker-objects of different groups (no marker clusters!) 
      key is the group name like absolute or relative metric values 
      layers[providerKey] = {
            marker: myMarkers,
            highlighted: this.checkedProvidersDict[providerKey],
            materialIcon: markersByProvider[providerKey].materialIcon,
            providerName: markersByProvider[providerKey].providerName,*/
    additionalDictOfMarkerObjects: {
      type: Object,
      default: () => ({
        absoluteMarkerGroup: [{}],
      }),
    },
  },
  data() {
    return {
      markerTargetsToShow: [] as Array<string>,
      germanyGeojsonLayerGroup: undefined as any,
      fitBoundsDelay: 300,
      SubClustersDictById: {} as any,
      error: { show: false, msg: "" },
      myGeojSonLayerGroup: undefined as any,
      /* dict  which contains the cluster layer of different transporttypes around point locationLatLon of the markers contained in 
      mobilityLayerGroupsDict of form {origin: {transportType1: layerClusterObj, locationLatLon: [array of lat, lon] }} */
      mobilityClusterGroupsDict: {
        origin: {
          layers: {},
          locationLatLon: undefined as any,
        },
        destination: {
          layers: {},
          locationLatLon: undefined as any,
        },
      } as any,
      /* dict with providers for each origin and destination around point locationLatLon of 
      form {origin: { layers: { provider1: { marker: [array of marker], materialIcon: ..., ... }, 
      locationLatLon: [array of lat, lon] }} */
      mobilityLayerGroupsDict: {
        origin: {
          layers: {},
          locationLatLon: undefined as any,
        },
        destination: {
          layers: {},
          locationLatLon: undefined as any,
        },
      } as any,
      trainstationsLayerGroupDict: {
        // origin/destination coordinates in 'location' for which the layerGroups were computed
        origin: {
          fernverkehr: undefined as any,
          regionalverkehr: undefined as any,
          locationLatLon: undefined as any,
        },
        destination: {
          fernverkehr: undefined as any,
          regionalverkehr: undefined as any,
          locationLatLon: undefined as any,
        },
      } as any,
      originLatLon: undefined as any,
      destinationLatLon: undefined as any,
      mapAttribution: "",
      bounds: null as any,
      zoom: 10,
      center: [47.31322, -1.319482],
      sidecol: "",
      checkedProvidersCpyDict: {} as any,
      // Threshold from which on regional trainstations should be shown
      zoomThresholdTrainstations: 12,
      mapObject: null as any,
      crs: CRS.Simple,
      mapOptions: {
        zoomControl: false, // disable zoom-controll
        zoomDelta: 0.25,
        zoomSnap: 0.25,
        wheelPxPerZoomLevel: 120,
        preferCanvas: true,
        renderer: L.canvas(),
        fadeAnimation: false,
        markerZoomAnimation: false,
        zoomAnimation: false,
      },
      zoomDebounceTimeout: null as any,
    };
  },
  computed: {
    // ...mapStores(useMapStore),
    destinationIcon() {
      return L.icon({
        iconUrl: "marker-icon-2x-red.png",
        shadowUrl: "marker-shadow.png",
        iconSize: [20, 35], // size of the icon
      });
    },
    originIcon() {
      return L.icon({
        iconUrl: "marker-icon-2x-blue.png",
        shadowUrl: "marker-shadow.png",
        iconSize: [20, 35], // size of the icon
      });
    },
    myColor() {
      return "green";
    },
    chosenMapType() {
      return this.mapUtilsObj.chosenMapType;
      // return this.mapStore.chosenMapType;
    },
  },
  methods: {
    optimizedGeoJsonRoutes() {
      // Return a simplified version of the routes to improve rendering
      if (!this.geojsonRoutes || this.geojsonRoutes.length === 0) {
        return [];
      }

      return this.geojsonRoutes.map((route) => {
        // Create a simplified copy with only necessary properties
        return {
          ...route,
          // If needed, we could add simplification logic here
        };
      });
    },
    convertStyleStringToObject(styleString) {
      const styleObject = {};
      const styleRules = styleString.split(";");
      styleRules.forEach((rule) => {
        const [property, value] = rule.split(":");
        if (property && value) {
          // Convert property names from kebab-case to camelCase
          const camelCaseProperty = property
            .trim()
            .replace(/-([a-z])/g, (g) => g[1].toUpperCase());
          styleObject[camelCaseProperty] = value.trim();
        }
      });
      return styleObject;
    },
    async initMap() {
      this.mapObject = (this.$refs.jmMap as any).leafletObject;
      this.mapUtilsObj.setMapObject(this.mapObject);
      // this.mapStore.setMapObject(this.mapObject);

      // Add optimized tile layer
      L.tileLayer("https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png", {
        maxZoom: 19,
        minZoom: 5,
        updateWhenIdle: true,
        updateWhenZooming: false,
        keepBuffer: 2,
        attribution:
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(this.mapObject);

      // Create resize observer
      let resizeObserver = new ResizeObserver(() => {
        this.handleResize();
      });

      // Attach resize observer to map container
      const mapContainer = this.mapObject.getContainer();
      if (mapContainer) {
        resizeObserver.observe(mapContainer);
      }

      // Handle initial bounds
      await this.setInitialBounds();

      // Disable animation for panning
      this.mapObject.options.animate = false;
    },
    async setInitialBounds() {
      let bounds;

      // Log initial conditions
      // console.log("originLatLon:", this.originLatLon);
      // console.log("destinationLatLon:", this.destinationLatLon);

      if (this.originLatLon && this.destinationLatLon) {
        // console.log("Creating bounds from origin and destination");
        bounds = L.latLngBounds([this.originLatLon, this.destinationLatLon]);
        // console.log("Created bounds:", bounds);
      } else if (this.originLatLon) {
        // console.log("Creating bounds from origin with radius");
        bounds = this.setBoundsWithRadius(this.originLatLon, 5000);
        // console.log("Created bounds:", bounds);
      } else if (this.destinationLatLon) {
        // console.log("Creating bounds from destination with radius");
        bounds = this.setBoundsWithRadius(this.destinationLatLon, 5000);
        // console.log("Created bounds:", bounds);
      } else {
        // console.log("Creating default Germany bounds");
        bounds = L.latLngBounds(
          [47.27, 5.87], // Southwest
          [55.1, 15.04], // Northeast
        );
        // console.log("Created bounds:", bounds);
      }

      if (bounds && bounds.isValid()) {
        // console.log("Bounds are valid, proceeding with fit");
        this.bounds = bounds;
        await this.fitBoundsWithRetry(bounds);
      } else {
        console.error("Invalid bounds created:", bounds);
      }
    },
    async handleResize() {
      if (this.bounds && this.mapObject) {
        // Batch DOM updates by using requestAnimationFrame
        requestAnimationFrame(() => {
          this.mapObject.invalidateSize({
            animate: false,
            pan: false,
          });
          this.fitBoundsWithRetry(this.bounds);
        });
      } else {
        this.setGermanyBounds();
      }
    },
    async fitBoundsWithRetry(
      bounds: L.LatLngBounds,
      attempts = 0,
      maxAttempts = 5,
    ) {
      if (!this.mapObject) {
        console.warn("Map not initialized");
        return;
      }

      try {
        this.mapObject.invalidateSize();
        this.mapObject.fitBounds(bounds, {
          padding: [30, 30],
          maxZoom: 13, // Allow zooming in closer
          animate: true,
          duration: 0.5,
        });
      } catch (error) {
        console.error("Error fitting bounds:", error);
        if (attempts < maxAttempts) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          await this.fitBoundsWithRetry(bounds, attempts + 1, maxAttempts);
        }
      }
    },
    setBoundsWithRadius(latLng: any, radiusKm: number) {
      try {
        const circle = L.circle(latLng, {
          weight: 0,
          fillOpacity: 0,
          radius: radiusKm * 1000, // Convert to meters
        });

        const bounds = circle.getBounds();
        return bounds;
      } catch (error) {
        console.error("Error in setBoundsWithRadius:", error);
        return null;
      }
    },
    zoomend() {
      const zoomLevel = this.mapObject.getZoom();

      // Emit the zoom event for other components to listen to
      eventBus.emit("map:zoom", zoomLevel);

      // Debounce tooltip updates to improve performance
      if (this.zoomDebounceTimeout) {
        clearTimeout(this.zoomDebounceTimeout);
      }

      this.zoomDebounceTimeout = setTimeout(() => {
        this.updateTooltipStyles(zoomLevel);
        this.updateTrainstationLayers(zoomLevel);
      }, 50);
    },

    updateTooltipStyles(zoomLevel) {
      var tooltips = document.querySelectorAll(".leaflet-container .circleTip");
      if (!tooltips.length) return;

      // Determine styles once and apply to all tooltips
      let fontSize, opacity;

      if (zoomLevel < 6.5) {
        fontSize = "0.4375rem"; // 7px / 16
        opacity = "0.6";
      } else if (zoomLevel >= 6.5 && zoomLevel < 7.5) {
        fontSize = "0.5625rem"; // 9px / 16
        opacity = "0.6";
      } else if (zoomLevel >= 7.5 && zoomLevel < 8.5) {
        fontSize = "0.6875rem"; // 11px / 16
        opacity = "0.6";
      } else if (zoomLevel >= 8.5 && zoomLevel < 9.5) {
        fontSize = "0.8125rem"; // 13px / 16
        opacity = "0.6";
      } else if (zoomLevel >= 9.5 && zoomLevel < 10.5) {
        fontSize = "0.875rem"; // 14px / 16
        opacity = "0.6";
      } else if (zoomLevel >= 10.5 && zoomLevel < 12) {
        fontSize = "0.9375rem"; // 15px / 16
        opacity = "0.7";
      } else if (zoomLevel >= 12 && zoomLevel < 14) {
        fontSize = "1rem"; // 16px / 16
        opacity = "0.8";
      } else {
        fontSize = "1.0625rem"; // 17px / 16
        opacity = "0.9";
      }

      tooltips.forEach((tooltip) => {
        var htmlTooltip = tooltip as HTMLElement;
        htmlTooltip.style.fontSize = fontSize;
        htmlTooltip.style.lineHeight = "1";
        htmlTooltip.style.borderRadius = "15px";
        htmlTooltip.style.opacity = opacity;
      });
    },

    updateTrainstationLayers(zoomLevel) {
      for (const target of ["origin", "destination"]) {
        // Handle trainstation layers visibility based on zoom level
        if (zoomLevel > this.zoomThresholdTrainstations) {
          if (
            this.trainstationsLayerGroupDict[target].regionalverkehr &&
            !this.mapObject.hasLayer(
              this.trainstationsLayerGroupDict[target].regionalverkehr,
            )
          ) {
            this.mapObject.addLayer(
              this.trainstationsLayerGroupDict[target].regionalverkehr,
            );
          }
        } else {
          if (
            this.trainstationsLayerGroupDict[target].regionalverkehr &&
            this.mapObject.hasLayer(
              this.trainstationsLayerGroupDict[target].regionalverkehr,
            )
          ) {
            this.mapObject.removeLayer(
              this.trainstationsLayerGroupDict[target].regionalverkehr,
            );
          }
        }
      }

      // Handle cluster icons only if we have clusters
      if (Object.keys(this.SubClustersDictById).length > 0) {
        this.updateClusterIcons();
      }
    },

    updateClusterIcons() {
      for (const target of ["origin", "destination"]) {
        for (const clusterName of Object.keys(this.SubClustersDictById)) {
          const cluster = this.SubClustersDictById[clusterName];
          let highlightedIcon = this.createHighlightedMobilityClusterIcon(
            cluster.layer,
            target,
            cluster.materialIcon,
          );
          if (highlightedIcon) {
            cluster.layer.setIcon(highlightedIcon);
          }
        }
      }
    },
    isDateSet() {
      // console.log("isDateSet is called.");
      const isArrivalSet = this.arrival && this.arrival !== "" ? true : false;
      const isDepartureSet =
        this.departure && this.departure !== "" ? true : false;
      return isArrivalSet || isDepartureSet;
    },
    computeLatLonObj(lonLatStr: any) {
      // console.log("Input lonLatStr:", lonLatStr);

      if (lonLatStr && lonLatStr.length > 0) {
        const lonLat = lonLatStr.split(",").map((val: any) => Number(val));
        // console.log("Parsed coordinates:", lonLat);
        const result = latLng(lonLat[1], lonLat[0]);
        // console.log("Created LatLng object:", result);
        return result;
      } else {
        // console.log("No coordinates provided");
        return undefined;
      }
    },
    setBounds(geojson: any) {
      // console.log("setBounds is called.");
      if (!geojson?.type) return;
      this.mapObject.invalidateSize();

      // Use L.geoJSON with optimized rendering settings
      const geoLayer = L.geoJSON(geojson, {
        coordsToLatLng: (coords) => {
          return L.latLng(coords[1], coords[0]);
        },
        style: {
          weight: 4,
          color: this.mapRouteColor,
          opacity: 0.6,
          fillOpacity: 0.1,
        },
      });

      const bounds = geoLayer.getBounds();
      this.mapObject.fitBounds(bounds);
      return bounds;
    },
    fitBoundsWithDelay(bounds: any, delay: number) {
      // console.log("fitBoundsWithDelay is called.");
      setTimeout(() => this.mapObject.fitBounds(bounds), delay);
    },
    /* get germany bounds from file which contains geojson of many countries, 
      by adding a transparrent geojson and get its bounds */
    getGermanyBounds() {
      // console.log("getGermanyBounds is called.");
      try {
        var myStyle = {
          fillColor: "grey",
          weight: 0,
          opacity: 0,
          fillOpacity: 0.0,
        };
        if (
          !this.germanyGeojsonLayerGroup ||
          !this.mapObject.hasLayer(this.germanyGeojsonLayerGroup)
        ) {
          this.germanyGeojsonLayerGroup = L.geoJson(world as any, {
            style: myStyle,
            filter: function (feature: any) {
              return feature.properties.name === "Germany";
            },
          });

          if (this.mapObject) {
            this.germanyGeojsonLayerGroup.addTo(this.mapObject);
          }
        }
        const bounds = this.germanyGeojsonLayerGroup.getBounds();

        // Validate bounds
        if (!bounds || !bounds.isValid()) {
          throw new Error("Invalid bounds generated");
        }
        return bounds;
      } catch (error) {
        console.error("Error getting Germany bounds:", error);
        return null;
      }
    },
    async setGermanyBounds() {
      if (!this.mapObject) {
        return;
      }
      // console.log("setGermanyBounds is called.");
      let bounds = this.getGermanyBounds();
      // Validate bounds before fitting
      if (!bounds || !bounds.isValid()) {
        console.warn("Invalid Germany bounds, using default bounds");
        // Provide default bounds for Germany
        bounds = L.latLngBounds(
          [47.27, 5.87], // Southwest corner
          [55.1, 15.04], // Northeast corner
        );
      }
      this.mapObject.invalidateSize();
      await this.fitBoundsWithRetry(bounds);
      return bounds;
    },
    /* check if both locations which are in different format are same.
      First one is in dict-format {lat: number, lon: number} and the other in array-format [lat, lon] */
    latLonDictAndArrayAreEqual(
      latLonDict: { lat: any; lng: any },
      latLonArray: Array<any>,
    ) {
      // console.log("latLonDictAndArrayAreEqual is called.");
      if (!latLonArray || !latLonArray) {
        return false;
      }
      const locAreSame =
        latLonDict &&
        latLonDict.lat === latLonArray[0] &&
        latLonDict.lng === latLonArray[1];
      return locAreSame;
    },
    /* creates icons with a custom shape and content defined as Div-block */
    createDivIcon(materialIcon: string, color: string) {
      // console.log("createDivIcon is called.");
      var html =
        '<div class="square-round-edges flex-box-center-items-horizontal" style="align-items: center; \
            opacity: 0.8;  background-color: ' +
        color +
        ' !important;"><span>' +
        '</span><span class="material-icons" style="color: white; font-size: 15px">' +
        materialIcon +
        "</span></div>";
      return L.divIcon({
        html: html,
        className: "mycluster",
        iconSize: L.point(22, 22),
      });
    },
  },
  async created() {
    // const mapStore = useMapStore();
    this.checkedProvidersCpyDict = { ...this.checkedProvidersDict };
  },
  mounted() {
    // console.log("mapUtilsObj=", this.mapUtilsObj);
  },
  watch: {
    height() {
      // console.log("height is called.");
      let bounds = undefined;
      if (
        !this.originLatLon &&
        !this.destinationLatLon &&
        (!this.geojsonRoutes ||
          (this.geojsonRoutes && this.geojsonRoutes.length === 0))
      ) {
        this.setGermanyBounds();
        bounds = this.getGermanyBounds();
      } else if (this.originLatLon && this.destinationLatLon) {
        bounds = L.latLngBounds([this.originLatLon, this.destinationLatLon]);
        this.mapObject.fitBounds(bounds);
      } else if (this.geojsonRoutes && this.geojsonRoutes.length > 0) {
        bounds = this.setBounds(this.geojsonRoutes[0]);
      } else if (this.originLatLon && !this.destinationLatLon) {
        bounds = this.setBoundsWithRadius(this.originLatLon, 2);
      } else if (!this.originLatLon && this.destinationLatLon) {
        bounds = this.setBoundsWithRadius(this.destinationLatLon, 2);
      }
      this.bounds = bounds;
    },
    geojsonRoutes() {
      // console.log("geojsonRoutes is called.");
      if (this.geojsonRoutes!.length > 0) {
        this.setBounds(this.geojsonRoutes![0]);
      }
    },
    async originLonLatStr() {
      // console.log("originLonLatStr is called.");
      this.originLatLon = this.computeLatLonObj(this.originLonLatStr);
      if (this.disableAutoFocus) {
        let bounds;
        // if both origin and destination are set, then bound to them, otherwise bound to germany map
        if (this.originLatLon && this.destinationLatLon) {
          bounds = L.latLngBounds([this.originLatLon, this.destinationLatLon]);
          this.mapObject?.invalidateSize();
          await this.fitBoundsWithRetry(bounds);
        } else {
          bounds = this.setGermanyBounds();
        }
        return;
      }
      let bounds = undefined;
      if (this.destinationLatLon && this.originLatLon && this.isDateSet()) {
        bounds = L.latLngBounds([this.originLatLon, this.destinationLatLon]);
        this.showMobilityMarkers(this.originLatLon, 5, "origin");
        this.showTrainstationsMarkers(this.originLatLon, 50, "origin");
        this.mapObject.fitBounds(bounds);
      } else if (this.originLatLon) {
        bounds = this.setBoundsWithRadius(this.originLatLon, 2);
        this.showMobilityMarkers(this.originLatLon, 5, "origin");
        this.showTrainstationsMarkers(this.originLatLon, 50, "origin");
      } else if (!this.destinationLatLon && !this.originLatLon) {
        this.removeAllMobilityMarkers("origin");
        this.removeAllMobilityMarkers("destination");
        /* if destination and origin are resetted, then show germany map again.
          Using timeout becasue for some reason a map in Africa is shown after setting germany map*/
        setTimeout(() => this.setGermanyBounds(), this.fitBoundsDelay);
      } else if (!this.originLatLon && this.destinationLatLon) {
        bounds = this.setBoundsWithRadius(this.destinationLatLon, 2);
        this.removeAllMobilityMarkers("origin");
      }
      this.bounds = bounds;
    },
    async destinationLonLatStr() {
      // console.log("destinationLonLatStr is called.");
      this.destinationLatLon = this.computeLatLonObj(this.destinationLonLatStr);
      if (this.disableAutoFocus) {
        let bounds;
        // if both origin and destination are set, then bound to them, otherwise bound to germany map
        if (this.originLatLon && this.destinationLatLon) {
          bounds = L.latLngBounds([this.originLatLon, this.destinationLatLon]);
          this.mapObject?.invalidateSize();
          await this.fitBoundsWithRetry(bounds);
        } else {
          bounds = this.setGermanyBounds();
        }
        return;
      }
      let bounds = undefined;
      // if both origin and destination are set then set the bounds to see both markers
      if (this.destinationLatLon && this.originLatLon && this.isDateSet()) {
        bounds = L.latLngBounds([this.originLatLon, this.destinationLatLon]);
        this.removeAllMobilityMarkers("destination");
        this.showMobilityMarkers(this.destinationLatLon, 5, "destination");
        this.showTrainstationsMarkers(
          this.destinationLatLon,
          50,
          "destination",
        );
        this.mapObject.fitBounds(bounds);
        // this.mapObject.fitBounds(bounds);
      }
      // if only destination is set, then focus to it
      else if (this.destinationLatLon) {
        bounds = this.setBoundsWithRadius(this.destinationLatLon, 2);
        this.removeAllMobilityMarkers("destination");
        this.showMobilityMarkers(this.destinationLatLon, 5, "destination");
        this.showTrainstationsMarkers(
          this.destinationLatLon,
          50,
          "destination",
        );
      } else if (!this.destinationLatLon && !this.originLatLon) {
        this.removeAllMobilityMarkers("origin");
        this.removeAllMobilityMarkers("destination");
        /* if destination and origin are resetted, then show germany map again.
          Using timeout becasue for some reason a map in Africa is shown after setting germany map*/
        setTimeout(() => this.setGermanyBounds(), this.fitBoundsDelay);
        bounds = this.getGermanyBounds();
      } else if (this.originLatLon && !this.destinationLatLon) {
        bounds = this.setBoundsWithRadius(this.originLatLon, 2);
        this.removeAllMobilityMarkers("destination");
      }
      this.bounds = bounds;
    },
    arrival() {
      // console.log("arrival is called.");
      if (this.destinationLatLon && this.originLatLon && this.isDateSet()) {
        let bounds = L.latLngBounds([
          this.originLatLon,
          this.destinationLatLon,
        ]);
        this.markerTargetsToShow = ["origin", "destination"];
        this.mapObject.fitBounds(bounds);
        this.bounds = bounds;
      }
    },
    departure() {
      // console.log("departure is called.");
      if (this.destinationLatLon && this.originLatLon && this.isDateSet()) {
        let bounds = L.latLngBounds([
          this.originLatLon,
          this.destinationLatLon,
        ]);
        this.mapObject.fitBounds(bounds);
        this.bounds = bounds;
      }
    },
    checkedProvidersDict: {
      handler: function (newVal, oldVal) {
        // console.log("checkedProvidersDict is called.");
        if (
          Object.keys(newVal).length !==
          Object.keys(this.checkedProvidersCpyDict).length
        ) {
          this.checkedProvidersCpyDict = { ...this.checkedProvidersDict };
          return;
        }
        const changedElement = Object.keys(newVal).filter(
          (key) => newVal[key] !== this.checkedProvidersCpyDict[key],
        );
        let providerName;
        try {
          providerName = changedElement[0];
        } catch {
          return;
        }
        this.toggleMarker(
          this.mobilityLayerGroupsDict.origin.layers,
          providerName,
          "origin",
        );
        this.toggleMarker(
          this.mobilityLayerGroupsDict.destination.layers,
          providerName,
          "destination",
        );
        this.checkedProvidersCpyDict = { ...this.checkedProvidersDict };
      },
      deep: true,
    },
  },
});
</script>
<style>
.circle {
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: red;
  border-radius: 15px;
  text-align: center;
}
.square-round-edges {
  width: 22px;
  height: 22px;
  line-height: 22px;
  background-color: blue;
  border-radius: 5px;
  text-align: center;
}
.legend {
  background: white;
  opacity: 0.8;
  border-radius: 10px;
  padding: 10px;
  line-height: 18px;
  color: #555;
}
.legend i {
  width: 18px;
  height: 18px;
  float: left;
  margin-right: 8px;
  border: 1px solid;
  border-radius: 50%;
}
</style>
